export default __webpack_public_path__ + "static/media/crossroads5.98eec049.webp";